var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 36,
    viewBox: "0 0 42 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.358 26.91c-.253.595-.506 1.104-.253 1.443.253.34.633.297 1.435.255h19.001c.422 0 1.309.085 1.478-.255.211-.509-.085-.89-.338-1.4L30.5 23.727h-19l-1.14 3.183z",
    fill: "#565294"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.312 29.826v.005c.386 2.233 2.392 3.84 4.692 3.84 2.34 0 4.304-1.606 4.69-3.875l.058-.223h6.09c.372 0 .741-.179.973-.492.234-.317.28-.724.14-1.084L31.22 23.52v-6.966c0-3.989-2.482-7.567-6.303-9.112l-.175-.085V6.03c0-1.953-1.504-3.575-3.44-3.7H21.047c-2.017 0-3.697 1.618-3.697 3.58v1.447l-.175.085c-3.821 1.545-6.303 5.123-6.303 9.112v7.006l-1.736 4.477c-.14.36-.093.767.14 1.084.23.311.558.492.973.492h6.037l.027.213zm1.159.074v-.001l-.085-.326h7.318l-.083.324a3.706 3.706 0 0 1-3.576 2.72c-1.689 0-3.174-1.128-3.574-2.717zm-6.818-2.811.003-.007 1.091-2.932h18.514l1.132 2.973.006.013a9.165 9.165 0 0 0 .187.344c.059.108.109.207.144.304a.716.716 0 0 1 0 .566c-.021.037-.07.076-.166.109a1.5 1.5 0 0 1-.364.061 6.267 6.267 0 0 1-.583.004c-.082-.002-.16-.004-.228-.004H11.696l-.132.007c-.332.017-.57.03-.757.009-.2-.023-.32-.082-.418-.209-.089-.114-.1-.266-.04-.483.05-.185.141-.39.245-.623l.06-.132zM23.276 6.953h-.002a10.205 10.205 0 0 0-2.27-.245c-.756 0-1.51.081-2.263.202l-.009.002-.344.084V5.909c0-1.373 1.186-2.526 2.616-2.526 1.43 0 2.616 1.153 2.616 2.526v1.127l-.344-.083zm-11.366 9.6c0-4.827 4.093-8.792 9.094-8.792 5.042 0 9.094 3.965 9.094 8.793v6.543H11.91v-6.543z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.628 12.892c-1.067.977-1.752 2.405-1.752 3.909 0 1.503.685 2.931 1.752 3.908M5.876 11.99C4.58 13.191 3.743 14.92 3.743 16.8c0 1.88.838 3.609 2.133 4.811M3.743 10.636A8.348 8.348 0 0 0 1 16.8a8.348 8.348 0 0 0 2.743 6.164M34.545 20.785c1.067-.978 1.753-2.406 1.753-3.91 0-1.503-.686-2.931-1.753-3.908M36.298 21.611c1.295-1.203 2.133-2.931 2.133-4.81 0-1.88-.838-3.609-2.133-4.812",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.43 22.964a8.348 8.348 0 0 0 2.743-6.164 8.348 8.348 0 0 0-2.742-6.164",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification_bell.69b40d0901e40d913149ba20a8f27ce3.svg";
export { ForwardRef as ReactComponent };